<div class="flex flex-column align-items-center text-center p-7" data-cy="page-error">
  <img src="./assets/icons/divisional-icons/bandaid-blue.svg" height="160px" class="mb-5" alt="Error Icon" />
  <h1 class="mt-0 mb-5 error-title">{{ title }}</h1>
  <p class="p2 mt-0 mb-4 error-message">{{ message }}</p>
  <p class="p3 mt-0 mb-4 text-black-400" *ngIf="!!errorMessages">Details: {{ errorMessages }}</p>
  <p class="p3 mt-0 mb-4 text-black-400" *ngIf="!!sentryIds">Issue ID(s): {{ sentryIds }}</p>
  <p class="p3 mt-0 mb-7 text-black-400">
    Contact us at <a href="tel:{{ ccsConfig.helpPhone }}">{{ ccsConfig.helpPhone }}</a> if you need additional support.
  </p>
  <button
    pButton
    type="button"
    label="Go to Dashboard"
    class="w-15rem mb-4"
    (click)="goToHome()"
    data-cy="go-to-dashboard-button"
  ></button>
  <button
    pButton
    type="button"
    label="Sign Out"
    class="p-button-text p-button-sm"
    (click)="signOut()"
    data-cy="sign-out-button"
  ></button>
</div>
